<div class="why-sat pt-5 pb-5">
  <div class="container">
    <div class="text-center ps-5 pe-5 res-plr-0">
      <h2 class="mb-3">Why Strait Air</h2>
      <p>As an independent company, we can arrange all types of solutions through our main carriers – or any other carrier – to provide you with the best time critical solution.</p>
    </div>

    <div class="row pt-3">
      <div class="col-lg-8">
        <div class="">
          <img src="../assets/images/why-sat.jpg" alt="why-sat" class="img-fluid">
        </div>
        <div class="specializaltion">
          <div class="row">
            <div class="col-lg-5 col-md-5">
              <ul class="list-unstyled pt-3 mb-3">
                <li>
                  <img src="../assets/images/icons/specialities.png" alt="your-specialist">Your Specialist
                </li>
                <li>
                  <img src="../assets/images/icons/nordic-partner.png" alt="your-nordic-partner">Nordic Partner
                </li>
                <li>
                  <img src="../assets/images/icons/agile-organization.png" alt="agile-organization">Agile Organization
                </li>
              </ul>
            </div>
            <div class="col-lg-7 col-md-7">
              <ul class="list-unstyled pt-3 mb-3">
                <li>
                  <img src="../assets/images/icons/large-partner-network.png" alt="large-partner-network">Global Partner Network
                </li>
                <li>
                  <img src="../assets/images/icons/independent-privately-owned.png" alt="independent-privately-owned">Independent and Privately Owned
                </li>
                <li>
                  <img src="../assets/images/icons/financial-strength.png" alt="financial-strength">Financial Strength
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 get-quote-form">
        <div class="pt-4 pb-4 ps-2 pe-2">
          <h3 class="text-center mb-4">Get A Quote!</h3>
          <form [formGroup]="satForm" action="" method="post">
            <div class="form-group pickup">
              <input type="text" class="form-control cust-form-control pickup-loc" id="formGroupExampleInput" placeholder="Pickup Location" formControlName="pickuploc">
            </div>
            <div class="form-group destination">
              <input type="text" class="form-control cust-form-control " id="formGroupExampleInput2" placeholder="Delivery Location" formControlName="deliveryloc">
            </div>
            <div class="form-group">
              <input type="date" [min]="date" class="form-control cust-form-control" id="formGroupExampleInput3" placeholder="Pickup Date" formControlName="pickupdate">
            </div>
            <div class="form-group">
              <input type="date" [min]="date" class="form-control cust-form-control" id="formGroupExampleInput4" placeholder="Delivery Date" formControlName="deliverydate">
            </div>
            <div class="form-group">
              <textarea class="form-control" id="exampleFormControlTextarea1" rows="1" placeholder="Cargo Description & Requirements" formControlName="reqdesc"></textarea>
            </div>
            <div class="form-group">
              <textarea class="form-control" id="exampleFormControlTextarea1" rows="1" placeholder="Contact Details" formControlName="contactdetails"></textarea>
            </div>
            <div class="form-group">
              <!-- <input type="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.emailid.errors }" id="formGroupExampleInput6" placeholder="Email" formControlName="emailid">
              <div *ngIf="submitted && f.emailid.errors" class="invalid-feedback">
                <div *ngIf="f.emailid.errors.required">Email is required</div>
                <div *ngIf="f.emailid.errors.pattern">Email must be a valid email address</div>
              </div> -->
              <input type="text" formControlName="emailid" placeholder="Email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.emailid.errors }" />
              @if (submitted && f.emailid.errors) {
                <div class="invalid-feedback">
                  @if (f.emailid.errors.required) {
                    <div>Email is required</div>
                  }
                  <!-- <div *ngIf="f.emailid.errors.email">Email must be a valid email address</div> -->
                  @if (f.emailid.errors.pattern) {
                    <div>Please enter a valid email address</div>
                  }
                </div>
              }
            </div>

            <p>We will respond same day, or for immediate support call your <a style="color: #E8882D; text-decoration: underline; cursor: pointer;" routerLink="/contact">local office</a></p>
            <re-captcha (resolved)="this.reCaptchaResolved($event)" formControlName="recaptchaReactive"
              siteKey="6LdIRe4ZAAAAAAEcOyDL6qxxpwgjFo2FYvstFpgQ">
            </re-captcha>
            @if (submitted && f.recaptchaReactive.errors) {
<div style="width: 100%; margin-top: 0.25rem; font-size: 80%;
    color: #dc3545;">Please resolve reCAPTCHA.</div>
            }
            <button [disabled]="this.satForm.invalid" (click)="submitSatForm();" type="submit" class="btn btn-primary mt-2">submit</button>

            <!-- The Modal -->
            @if (this.mailSent) {
              <div class="mailmodal modal" id="mailack">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                      <!-- <h4 class="modal-title">Modal Heading</h4> -->
                      <button type="button" class="close" (click)="this.mailSent = !this.mailSent">&times;</button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                      Thank you for your request, a Strait Air Transport employee will be in contact shortly.
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
